// extracted by mini-css-extract-plugin
var _1 = "BankFormStyle-module__bank-form___csohx";
var _2 = "BankFormStyle-module__bank-form___csohx";
var _3 = "BankFormStyle-module__error___GTsyU";
var _4 = "BankFormStyle-module__fileInput___b6Pi8";
var _5 = "BankFormStyle-module__headline___MvE6w";
var _6 = "BankFormStyle-module__message___uMyGO";
var _7 = "BankFormStyle-module__presentation___t54de";
var _8 = "BankFormStyle-module__select___AALzQ";
var _9 = "BankFormStyle-module__uploadBtn___pBtVW";
export { _1 as "bank-form", _2 as "bankForm", _3 as "error", _4 as "fileInput", _5 as "headline", _6 as "message", _7 as "presentation", _8 as "select", _9 as "uploadBtn" }
